import React from 'react';

const BOMView = () => {
  return <></>;
};

export default BOMView;
